import { createBrowserRouter } from 'react-router-dom';
import Layout from '../layout';
import { AuthRoutes, AppRoutes } from './AppRoutes';
import PrivateRoute from './PrivateRoute';
import RouteRedirect from './RouteRedirect';
import { routes } from './routes';
import Auth from '../auth';
import Error404 from '../components/pages/others/errorPage/Error404';
import RoleRoute from './RoleRoute';

import LeaderBoard from '../pages/users/LeaderBoard';
import CoursesList from '../pages/courses/CoursesList';
import UploadCourses from '../pages/courses/UploadCourses';
import Users from '../pages/users/Users';
import FeedBacksPage from '../pages/feedBacks/FeedBacksPage';
import DashboardPage from '../pages/dashboard/DashboardPage';
import UserStatPage from '../pages/dashboard/UserStatPage';
import LeadsListPage from '../pages/leads/LeadsListPage';
import LeadsDetails from '../components/leads/[id]/LeadsDetails';
import CrmControlPage from '../pages/control/CrmControlPage';
import Engagement from '../components/leads/engagement';
import EngagementsDetails from '../components/leads/engagement/[id]';
import ScoringsPage from '../pages/scorings/ScoringsPage';
import StudentCoursesList from '../pages/courses/StudentCoursesList';
import StudentExamCalendar from '../pages/courses/StudentExamCalendar';
import UserDetailsStats from '../components/dashboard/userStats/[userId]/UserDetailsStats';
import UsersProfile from '../pages/applications/users/UsersProfile';
import EditProfile from '../pages/applications/users/EditProfile';
import AssignToCourse from '../pages/courses/AssignToCourse';
import CourseDetails from '../pages/courses/CourseDetails';
import LessonDetails from '../pages/courses/LessonDetails';
import ExamList from '../pages/courses/ExamList';
import MeetBot from '../pages/meetBot/MeetBot';
import BotTranscription from '../components/meetBot/[transcriptId]/BotTranscription';
import CreateAssistantExam from '../pages/assistant/CreateAssistantExam';
import ExamDetailsPage from '../pages/exams/ExamDetailsPage';
import LeadsDetailsPage from '../pages/leads/LeadsDetailsPage';
import Examinations from '../components/leads/examinations';
import StudentCourseDetails from '../components/courses/studentCoursesList/details/[id]';
import StudentLessonDetails from '../components/courses/studentCoursesList/lessonDetails';
import { UserRole } from '../types/Forms';
import Prompts from '../pages/openai/Prompts';
import { UnprocessedTranscriptions } from '../components/control/crm/unprocessed';
import CrmChartsPage from '../pages/control/CrmChartsPage';

const basename = '/';

const assistantRoutes = [
  //Dashboard
  { path: routes.Dashboard.Default, element: <DashboardPage /> },
  { path: routes.Dashboard.UserStats, element: <UserStatPage /> },
  { path: routes.Users.users, element: <Users /> },
  { path: routes.Dashboard.UserDetailsStats, element: <UserDetailsStats /> },

  //Users
  { path: routes.Users.users, element: <Users /> },
  { path: routes.Users.AssignToCourse, element: <AssignToCourse /> },

  //Exams
  { path: routes.Exams.ExamList, element: <ExamList /> },
  { path: routes.Exams.MeetBot, element: <MeetBot /> },
  { path: routes.Exams.MeetBotTranscription, element: <BotTranscription /> },
  { path: routes.Exams.CreateAssistantExam, element: <CreateAssistantExam /> },
  { path: routes.Exams.ExamDetails, element: <ExamDetailsPage /> },
  { path: routes.Exams.LeaderBoard, element: <LeaderBoard /> },

  //Feedbacks
  { path: routes.Feedbacks.FeedBacks, element: <FeedBacksPage /> },
  //Leads
  { path: routes.Leads.LeadsList, element: <LeadsListPage /> },
  { path: routes.Leads.LeadsDetails, element: <LeadsDetailsPage /> },
  { path: routes.Leads.Engagement, element: <Engagement /> },
  { path: routes.Leads.EngagementDetails, element: <EngagementsDetails /> },
  { path: routes.Leads.Examinations, element: <Examinations /> },
  //SCORINGS
  { path: routes.Scorings.scoringsAvg, element: <ScoringsPage /> },
  // CONTROL
  { path: routes.Control.UnprocessedTranscriptions, element: <UnprocessedTranscriptions /> },
  //  { path: routes.Leads.ExaminationsDetails, element: <CRMExamDetails /> },
];

const studentRoutes = [
  {
    path: routes.Students.AllStudentCourses,
    element: <StudentCoursesList />,
  },
  {
    path: routes.Students.StudentCourseDetailsPage,
    element: <StudentCourseDetails />,
  },

  {
    path: routes.Students.StudentCourseLessonDetailsPage,
    element: <StudentLessonDetails />,
  },
  {
    path: routes.Students.StudentPrivateCourses,
    element: <StudentCoursesList />,
  },
  {
    path: routes.Students.MyCoursesCourseDetailsPage,
    element: <StudentCourseDetails />,
  },

  {
    path: routes.Students.MyCoursesCourseLessonDetailsPage,
    element: <StudentLessonDetails />,
  },
  {
    path: routes.Students.MyCoursesExamCalendar,
    element: <StudentExamCalendar />,
  },
];

const commonRoutes = [
  { path: routes.Users.Profile, element: <UsersProfile /> },
  { path: routes.Users.Edit, element: <EditProfile /> },
];

const RouterProvider = createBrowserRouter(
  [
    {
      element: <PrivateRoute />,
      children: [
        { path: routes.Home, element: <Auth />, index: true },
        { path: routes.Login, element: <Auth /> },
      ],
    },
    {
      element: <RouteRedirect />,
      children: [
        {
          element: <Layout />,
          children: [
            {
              element: <RoleRoute allowedRoles={[UserRole.ADMIN, UserRole.ASSISTANT]} />,
              children: assistantRoutes,
            },
            {
              element: <RoleRoute allowedRoles={[UserRole.ADMIN]} />,
              children: [
                { path: routes.Control.Crm, element: <CrmControlPage /> },
                { path: routes.Control.CrmCharts, element: <CrmChartsPage /> },

                { path: routes.Openai.Prompts, element: <Prompts /> },

                { path: routes.Courses.CoursesList, element: <CoursesList /> },
                {
                  path: routes.Courses.CourseDetailsPage,
                  element: <CourseDetails />,
                },
                { path: routes.Courses.UploadCourses, element: <UploadCourses /> },
                {
                  path: routes.Courses.CourseDetailsPage,
                  element: <CourseDetails />,
                },
                {
                  path: routes.Courses.LessonDetailsPage,
                  element: <LessonDetails />,
                },
              ],
            },
            {
              element: <RoleRoute allowedRoles={[UserRole.STUDENT]} />,
              children: studentRoutes,
            },

            // ✅ Routes open to all logged-in users
            ...commonRoutes,
          ],
        },

        {
          children: AuthRoutes,
        },
      ],
    },
    { path: '*', element: <Error404 /> },
  ],
  {
    basename,
  },
);

export default RouterProvider;
